import { Entity } from '@inter-ikea-core/core';
import { ProductDesign } from '@inter-ikea-storageone/range';
import { useCore } from 'contexts/core';
import { getProductEntities } from 'ducks/core';
import { useAppDispatch } from 'ducks/hooks';
import { showInfoMessage } from 'ducks/layout';
import { getMarketProducts } from 'ducks/products';
import { getSelectedRange } from 'ducks/range';
import { changeFrameColor } from 'rangeConfig/shared/utils/colorUtils/changeFrameColor';
import { getFramesInScene } from 'rangeConfig/shared/utils/colorUtils/utils';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ChangeColor from './ChangeColor';

const ChangeFrameColor = () => {
  const coreApi = useCore();
  const dispatch = useAppDispatch();
  const productEntities = useSelector(getProductEntities);
  const products = useSelector(getMarketProducts);
  const range = useSelector(getSelectedRange);
  const [frameEntities, setFrameEntities] = useState<Entity[]>([]);

  useEffect(() => {
    setFrameEntities(getFramesInScene(coreApi, range));
  }, [coreApi, productEntities, range]);

  const checkNewSolution = (oldFrames: Entity[]): boolean => {
    const newFrames = getFramesInScene(coreApi, range);
    let nbrOfUnchangedFrames = 0;
    newFrames.forEach(frame => {
      if (oldFrames.includes(frame)) {
        nbrOfUnchangedFrames += 1;
      }
    });
    if (nbrOfUnchangedFrames === newFrames.length) {
      dispatch(showInfoMessage({ message: 'storageone.changeColorMissingFramesMessage' }));
      return true;
    }
    if (nbrOfUnchangedFrames > 0) {
      dispatch(showInfoMessage({ message: 'storageone.changeColorSomeMissingFramesMessage' }));
      return true;
    }
    return false;
  };

  const onChangeColor = (design: ProductDesign) => {
    const notReplaceableInteriorFound = changeFrameColor(coreApi, frameEntities, design, products);

    const unchangedFrames = checkNewSolution(frameEntities);
    if (notReplaceableInteriorFound && !unchangedFrames) {
      dispatch(showInfoMessage({ message: 'storageone.changeColorInteriorsUnavailableMessage' }));
    }
  };

  return (
    <ChangeColor
      entities={frameEntities}
      onChangeColor={onChangeColor}
      defaultColor={ProductDesign.WHITE}
    />
  );
};

export default ChangeFrameColor;
